import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  idToken: null,
  isError: null,
  errorMessage: null,
  message: null,
  mqttTrx: null,
  unsubscribeIsError: false,
  unsubscribeIsLoading: false,
  unsubscribeMessage: null,
  redirectUrl: null,

  caseLogsLoading: false,
  caseLogsData: null,
  caseLogsIsError: false,
  caseLogsPagination: null,
  caseLogsLoadMore: false,

  inviteCaseMemberIsError: false,
  inviteCaseMemberLoading: false,

  reconciliationLoading: false,
  reconciliationData: null,
  reconciliationIsError: false,
  reconciliationFilter: null,

  responseCodeLoading: false,
  responseCodeData: null,
  responseCodeIsError: false,

  settlementRateLoading: false,
  settlementRateData: null,
  settlementRateIsError: false,

  securityCodeLoading: false,
  securityCodeData: null,
  securityCodeIsError: false,

  billingLoading: false,
  billingData: null,
  billingIsError: false,
  billingFilter: null,

  billingDetailsLoading: false,
  billingDetails: null,
  billingDetailsIsError: false,
  billingDataMerchantFee: null,

  billerDetailsLoading: false,
  billerDetails: null,
  billerDetailsIsError: false,
  billerDataMerchantFee: null,

  collatedDataLoading: false,
  collatedData: null,
  collatedDataIsError: false,
  collatedDataFilter: null,
  collatedTotalCount: 0,
  collatedMqttLoading: false,
  analyzeMqttLoading: false,

  generateReportDataLoading: false,
  generateReportData: null,
  generateReportDataIsError: false,

  downloadSettlementReportDataLoading: false,
  downloadSettlementReportDataIsError: false,

  generateMonthReportDataLoading: false,
  generateMonthReportData: null,
  generateMonthReportDataIsError: false,

  downloadMonthlyReconciledReportLoading: false,
  downloadMonthlyReconciledReportIsError: false,

  parseNotifierIsError: false,
  parseNotifierMessage: null,

  settlementReportLoading: false,
  settlementReportLoadMore: false,
  settlementReportData: null,
  settlementReportIsError: false,
  settlementReportPagination: null,
  settlementReportFilter: null,

  monthlySettlementReportLoading: false,
  monthlySettlementReportLoadMore: false,
  monthlySettlementReportData: null,
  monthlySettlementReportIsError: false,
  monthlySettlementReportPagination: null,
  monthlySettlementReportFilter: null,

  unreconciledReportLoading: false,
  unreconciledReportLoadMore: false,
  unreconciledReportData: null,
  unreconciledReportIsError: false,
  unreconciledReportPagination: null,
  unreconciledReportFilter: null,

  downloadUnreconciledLoading: false,
  downloadUnreconciledIsError: false,

  financeDashboardDataLoading: false,
  financeDashboardData: null,
  financeDashboardDataIsError: false,
  financeDashboardDataFilter: null,
  financeDashboardDataPagination: null,

  allReconciledDataLoading: false,
  allReconciledData: null,
  allReconciledDataIsError: false,
  allReconciledDataFilter: null,
  allReconciledDataPagination: null,

  unsettledTransactionLoading: false,
  unsettledTransactionIsError: false,

  caseDetailsLoading: false,
  caseDetail: null,
  caseDetailIsError: false,

  presignedUrlsForCaseFileLoading: false,
  presignedUrlsForCaseFileData: [],
  presignedUrlsForCaseFileIsError: false,

  sendDiscussionLoading: false,
  sendDiscussionIsError: false,

  caseDiscussionLoading: false,
  caseDiscussionData: null,
  caseDiscussionIsError: false,
  caseDiscussionFilter: null,
  caseDiscussionPagination: null,
  caseDiscussionLoadMore: false,

  escalateLoading: false,

  likeLoading: false,
  likeIsError: false,
  likedID: null,

  escalatedCaseDataLoading: false,
  escalatedCaseData: null,
  escalatedCaseDataIsError: false,
  escalatedCaseDataFilter: null,
  escalatedCaseDataPagination: null,
  escalatedCaseDataLoadMore: false,

  updateBankFileIsLoading: false,
  updateBankFileIsError: false,
  uploadedBankFilesLoading: false,
  uploadedBankFiles: null,
  uploadedBankFilesIsError: false,
  uploadedBankFilesPagination: null,
  activeUploadedBank: null,
  activeBankFilter: null,
  activePagination: null,

  uploadedBankTransactionLoading: false,
  uploadedBankTransaction: null,
  uploadedBankTransactionIsError: false,
  uploadedBankTransactionPagination: null,
  updateBankTransactionIsError: false,
  bankTransactionFilter: null,

  bankTransactionStatistics: null,
  bankTransactionStatisticsIsError: false,

  paynamicsBank: null,
  updateBankRemitIsLoading: false,
  updateBankTransactionIsLoading: false,

  remittingChannelSchedule: null,
  remittingChannelScheduleLoading: false,
  remittingChannelScheduleIsError: false,
  activeRemittingChannelSchedule: null,
  addRemittingChannelScheduleIsError: false,
  editRemittingChannelScheduleIsError: false,

  deleteBankFileAndTransactionsIsLoading: false,
  deleteBankFileAndTransactionsIsError: false,

  transactionList: null,
  transactionListCollection: null,
  transactionListTemp: null,
  transactionListCount: 0,
  transactionListPage: 1,
  fetchingTrxList: false,
  fetchingMoreTrx: false,
  
  trxDetails: null,
  fetchingTrxDetails: false,

  pnxBankColumn: null,

  otcTransactionsData: null,
  otcTransactionsLoading: false,
  otcTransactionsIsError: false,
  otcTransactionsFilter: null,

  csvDownloadFile: null,
  isDownloadCsv: false,

  excelDownloadList: null,
  fetchingExcelDownloadList: false,

  previousDownloads: null,
  fetchingPrevDownloads: false,

  downloadStatus: null,

  merchants: null,
  fetchingMerchants: false,

  fetchingDownloadReport: false,
  fetchedDownloadReport: null,

  // Finance Operations
  financeOperationsLoading: false,
  financeOperations: null,
  financeOperationsIsError: false,
  financeOperationsFilter: null,
  financeOperationsPagination: null,
  financeOperationsLoadMore: false,
  activeFinanceOperations: null,
  activeFinanceOperationsLoading: null,

  fetchingReversalRequest: false,
  fetchedReversalRequest: null,

  presignedUrlsReversalAttachmentLoading: false,
  presignedUrlsReversalAttachment: null,
  presignedUrlsReversalAttachmentIsError: false,

  financeOperationsLogsLoading: false,
  financeOperationsLogsData: null,
  financeOperationsLogsIsError: false,
  financeOperationsLogsPagination: null,
  financeOperationsLogsLoadMore: false,

  downloadVatExemptionLoading: false,
  downloadVatExemptionIsError: false,

  decryptedAccountNumber: null,
  decryptedAccountNumberLoading: false,
  decryptedAccountNumberIsError: false,

  invoicePDFUrl: null,
  invoicePDFUrlLoading: false,
  invoicePDFUrlIsError: false,
  
  vatReversalAttachmentUrl: null,
  vatReversalAttachmentUrlLoading: false,
  vatReversalAttachmentUrlIsError: false,

  paymentProofPDFUrl: null,
  paymentProofPDFUrlLoading: false,
  paymentProofPDFUrlIsError: false,

  financeUsers: null,
  financeUsersLoading: false,
  financeUsersIsError: false,

  presignedUrlEsignatureLoading: false,
  presignedUrlEsignature: null,
  presignedUrlEsignatureIsError: false,

  presignedUrlsPaymentProofLoading: false,
  presignedUrlsPaymentProof: null,
  presignedUrlsPaymentProofIsError: false,
  downloadPaymentProofLoading: false,
  downloadPaymentProofIsError: false,

  summaryBreakdownReportLoading: false,
  summaryBreakdownReportIsError: false,

  // Settlement Config
  settlementCycleDataLoading: false,
  settlementCycleData: null,
  settlementCycleDataIsError: false,
  settlementCycleDataFilter: null,
  settlementCycleDataPagination: null,
  settlementCycleDataLoadMore: false,
  activeSettlementCycle: null,
  activeSettlementCycleLoading: null,

  activeSettlementRate: null,
  activeSettlementRateLoading: null,

  billingAdditionalFeeDataLoading: false,
  billingAdditionalFeeData: null,
  billingAdditionalFeeDataIsError: false,
  billingAdditionalFeeDataFilter: null,
  billingAdditionalFeeDataPagination: null,
  billingAdditionalFeeDataLoadMore: false,

  activeBillingAdditionalFee: null,
  activeBillingAdditionalFeeLoading: null,
  activeBillingAdditionalFeeIsError: null,
  activeBillingAdditionalFeeErrorMessage: null,

  billingConfigurationLogsLoading: false,
  billingConfigurationLogsData: null,
  billingConfigurationLogsIsError: false,
  billingConfigurationLogsPagination: null,
  billingConfigurationLogsLoadMore: false,

  presignedUrlsAddendumLoading: false,
  presignedUrlsAddendum: null,
  presignedUrlsAddendumIsError: false,

  feeHistoryLoading: false,
  feeHistoryData: null,
  feeHistoryIsError: false,
  feeHistoryPagination: null,
  feeHistoryLoadMore: false,

  downloadAddendumDocumentLoading: false,
  downloadAddendumDocumentIsError: false,

  allGeneratedSettlementSummaryReportDataLoading: false,
  allGeneratedSettlementSummaryReportFileData: null,
  allGeneratedSettlementSummaryReportFileDataIsError: false,
  allGeneratedSettlementSummaryReportFileDataPagination: false,

  isDownloadingSettlementSummaryReportFile: false,
  isDownloadingSettlementSummaryReportFileError: null,

  summaryBreakdownReportPchannelFilter: [],
  isSavingSummaryBreakdownReportPchannelFilter: null,

  generatedMonthlyReconciledFilter: [],

  foundSnowflakeTransactionData: null,
  selectedUploadedData: null,

  presignedUrlsForReconProofLoading: false,
  presignedUrlsForReconProofData: null,
  presignedUrlsForReconProofIsError: false,

  downloadManualReconProofLoading: false,
  downloadManualReconProofIsError: false,

  transactionRequestManagementLoading: false,
  transactionRequestManagementIsError: true,

  transactionRequestsLoading: false,
  transactionRequests: null,
  transactionRequestsIsError: false,
  transactionRequestsFilter: null,
  transactionRequestsPagination: null,

  approvedListFilteredDate: null,
  approvedListFilteredDateLoading: false,
  approvedListFilteredDateIsError: false,

  approvedPaymentChannelData: null,
  approvedPaymentChannelDataLoading: false,
  approvedPaymentChannelDataIsError: false,

  unreconciledPTIGroupMerchantData: null,
  unreconciledPTIGroupMerchantDataLoading: false,
  unreconciledPTIGroupMerchantDataIsError: false,

  generateSummaryReconciliationReportLoading: false,
  generateSummaryReconciliationReportIsError: false,

  isDownloadingGeneratedSummaryReconciliationReportFile: false,
  isDownloadGeneratedSummaryReconciliationReportFile: false,

  generatedSummaryReconciliationReportData: null,
  generatedSummaryReconciliationReportDataLoading: false,
  generatedSummaryReconciliationReportDataIsError: false,
  generatedSummaryReconciliationReportDataPagination: null,
  generatedSummaryReconciliationReportDataFilter: null,

  downloadUploadedBankFileLoading: false,
  downloadUploadedBankFileIsError: false,

  fetchingMerchantParams: false,
  fetchedMerchantParams: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.CLEAR_MESSAGE:
      return {
        ...state,
        message: null,
        errorMessage: null,
        idToken: null,
        activeBillingAdditionalFeeErrorMessage: null
      };
    case actions.MQTT_TRX:
      return {
        ...state,
        mqttTrx: action.payload
      };

    case actions.STORING_ATTACHED_CASE_FILES_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsForCaseFileLoading: action.loading
      };

    case actions.STORE_ATTACHED_CASE_FILES_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsForCaseFileLoading: action.loading,
        presignedUrlsForCaseFileData: action.result,
        presignedUrlsForCaseFileIsError: false
      };

    case actions.STORE_ATTACHED_CASE_FILES_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsForCaseFileLoading: action.loading,
        presignedUrlsForCaseFileData: action.result,
        presignedUrlsForCaseFileIsError: true
      };

    case actions.SENDING_DISCUSSION_ITEM:
      return {
        ...state,
        sendDiscussionLoading: true
      };

    case actions.SEND_DISCUSSION_ITEM_SUCCESS:
      return {
        ...state,
        sendDiscussionLoading: action.loading,
        sendDiscussionIsError: false,
        errorMessage: action.message
      };

    case actions.SEND_DISCUSSION_ITEM_FAILED:
      return {
        ...state,
        sendDiscussionLoading: action.loading,
        sendDiscussionIsError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_CASE_LOGS:
      return {
        ...state,
        caseLogsLoading: action.loading
      };

    case actions.FETCH_CASE_LOGS_SUCCESS:
      return {
        ...state,
        caseLogsLoading: action.loading,
        caseLogsData: action.result,
        caseLogsIsError: false,
        caseLogsPagination: action.pagination,
        caseLogsLoadMore: false
      };

    case actions.LOADING_MORE_CASE_LOGS:
      return {
        ...state,
        caseLogsLoadMore: true
      };

    case actions.FETCH_CASE_LOGS_FAILED:
      return {
        ...state,
        caseLogsLoading: action.loading,
        caseLogsData: action.result,
        caseLogsIsError: true,
        caseLogsPagination: action.pagination,
        caseLogsLoadMore: false
      };
    case actions.RESET_CASE_LOGS:
      return {
        ...state,
        caseLogsLoading: false,
        caseLogsData: null,
        caseLogsIsError: false,
        caseLogsPagination: null,
        caseLogsLoadMore: false
      };
    case actions.UNSUBSCRIBING_NOTIFICATION_CREDENTIAL:
      return {
        ...state,
        unsubscribeIsError: false,
        unsubscribeIsLoading: true
      };

    case actions.UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_SUCCESS:
      return {
        ...state,
        unsubscribeIsLoading: action.loading,
        unsubscribeMessage: action.message,
        unsubscribeIsError: false,
        redirectUrl: action.redirectUrl
      };

    case actions.UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_FAILED:
      return {
        ...state,
        unsubscribeIsLoading: action.loading,
        unsubscribeMessage: action.message,
        unsubscribeIsError: true,
        redirectUrl: action.redirectUrl
      };
    case actions.UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_CLEAR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
        unsubscribeIsLoading: false,
        redirectUrl: null
      };

    case actions.FETCHING_RECONCILIATION_DATA_BY_PCHANNEL:
      return {
        ...state,
        reconciliationData: null,
        reconciliationLoading: true
      };

    case actions.FETCH_RECONCILIATION_DATA_BY_PCHANNEL_SUCCESS:
      return {
        ...state,
        reconciliationLoading: action.loading,
        reconciliationData: action.result,
        reconciliationIsError: false,
        reconciliationFilter: action.filter
      };

    case actions.FETCH_RECONCILIATION_DATA_BY_PCHANNEL_FAILED:
      return {
        ...state,
        reconciliationLoading: action.loading,
        reconciliationData: action.result,
        reconciliationIsError: true,
        reconciliationFilter: action.filter
      };

    case actions.RESET_RECONCILIATION_DATA_BY_PCHANNEL:
      return {
        ...state,
        reconciliationLoading: false,
        reconciliationData: null,
        reconciliationIsError: false,
        reconciliationFilter: null
      };

    case actions.FETCHING_RESPONSE_CODE:
      return {
        ...state,
        responseCodeData: null,
        responseCodeLoading: true
      };

    case actions.FETCH_RESPONSE_CODE_SUCCESS:
      return {
        ...state,
        responseCodeLoading: action.loading,
        responseCodeData: action.result,
        responseCodeIsError: false,
        responseCodeFilter: action.filter
      };

    case actions.FETCH_RESPONSE_CODE_FAILED:
      return {
        ...state,
        responseCodeLoading: action.loading,
        responseCodeData: action.result,
        responseCodeIsError: true
      };

    case actions.ADDING_RESPONSE_CODE:
      return {
        ...state,
        responseCodeIsError: false,
        responseCodeLoading: true
      };

    case actions.ADD_RESPONSE_CODE_SUCCESS:
      return {
        ...state,
        responseCodeLoading: action.loading,
        errorMessage: action.message,
        responseCodeIsError: false
      };

    case actions.ADD_RESPONSE_CODE_FAILED:
      return {
        ...state,
        responseCodeLoading: action.loading,
        errorMessage: action.message,
        responseCodeIsError: true
      };

    case actions.EDITING_RESPONSE_CODE:
      return {
        ...state,
        responseCodeIsError: false,
        responseCodeLoading: true
      };

    case actions.EDIT_RESPONSE_CODE_SUCCESS:
      return {
        ...state,
        responseCodeLoading: action.loading,
        errorMessage: action.message,
        responseCodeIsError: false
      };

    case actions.EDIT_RESPONSE_CODE_FAILED:
      return {
        ...state,
        responseCodeLoading: action.loading,
        errorMessage: action.message,
        responseCodeIsError: true
      };

    case actions.EDITING_SETTLEMENT_RATE:
      return {
        ...state,
        settlementRateIsError: false,
        settlementRateLoading: true
      };

    case actions.EDIT_SETTLEMENT_RATE_SUCCESS:
      return {
        ...state,
        settlementRateLoading: action.loading,
        errorMessage: action.message,
        settlementRateIsError: false
      };

    case actions.EDIT_SETTLEMENT_RATE_FAILED:
      return {
        ...state,
        settlementRateLoading: action.loading,
        errorMessage: action.message,
        settlementRateIsError: true
      };

    case actions.CHANGING_STATUS_RESPONSE_CODE:
      return {
        ...state,
        responseCodeIsError: false,
        responseCodeLoading: true
      };

    case actions.CHANGE_STATUS_RESPONSE_CODE_SUCCESS:
      return {
        ...state,
        responseCodeLoading: action.loading,
        errorMessage: action.message,
        responseCodeIsError: false
      };

    case actions.CHANGE_STATUS_RESPONSE_CODE_FAILED:
      return {
        ...state,
        responseCodeLoading: action.loading,
        errorMessage: action.message,
        responseCodeIsError: true
      };

    case actions.FETCHING_SECURITY_CODE:
      return {
        ...state,
        securityCodeData: null,
        securityCodeLoading: true
      };

    case actions.FETCH_SECURITY_CODE_SUCCESS:
      return {
        ...state,
        securityCodeLoading: action.loading,
        securityCodeData: action.result,
        securityCodeIsError: false,
        securityCodeFilter: action.filter
      };

    case actions.FETCH_SECURITY_CODE_FAILED:
      return {
        ...state,
        securityCodeLoading: action.loading,
        securityCodeData: action.result,
        securityCodeIsError: true
      };

    case actions.ADDING_SECURITY_CODE:
      return {
        ...state,
        securityCodeIsError: false,
        securityCodeLoading: true
      };

    case actions.ADD_SECURITY_CODE_SUCCESS:
      return {
        ...state,
        securityCodeLoading: action.loading,
        errorMessage: action.message,
        securityCodeIsError: false
      };

    case actions.ADD_SECURITY_CODE_FAILED:
      return {
        ...state,
        securityCodeLoading: action.loading,
        errorMessage: action.message,
        securityCodeIsError: true
      };

    case actions.EDITING_SECURITY_CODE:
      return {
        ...state,
        securityCodeIsError: false,
        securityCodeLoading: true
      };

    case actions.EDIT_SECURITY_CODE_SUCCESS:
      return {
        ...state,
        securityCodeLoading: action.loading,
        errorMessage: action.message,
        securityCodeIsError: false
      };

    case actions.EDIT_SECURITY_CODE_FAILED:
      return {
        ...state,
        securityCodeLoading: action.loading,
        errorMessage: action.message,
        securityCodeIsError: true
      };

    case actions.CHANGING_STATUS_SECURITY_CODE:
      return {
        ...state,
        securityCodeIsError: false,
        securityCodeLoading: true
      };

    case actions.CHANGE_STATUS_SECURITY_CODE_SUCCESS:
      return {
        ...state,
        securityCodeLoading: action.loading,
        errorMessage: action.message,
        securityCodeIsError: false
      };

    case actions.CHANGE_STATUS_SECURITY_CODE_FAILED:
      return {
        ...state,
        securityCodeLoading: action.loading,
        errorMessage: action.message,
        securityCodeIsError: true
      };

    case actions.FETCHING_BILLING_DATA_BY_MERCHANT:
      return {
        ...state,
        billingData: null,
        billingLoading: true
      };

    case actions.FETCH_BILLING_DATA_BY_MERCHANT_SUCCESS:
      return {
        ...state,
        billingLoading: false,
        billingData: action.result,
        billingIsError: false,
        billingFilter: action.filter
      };

    case actions.FETCH_BILLING_DATA_BY_MERCHANT_FAILED:
      return {
        ...state,
        billingLoading: false,
        billingData: action.result,
        billingIsError: true
      };

    case actions.RESET_BILLING_DATA_BY_MERCHANT:
      return {
        ...state,
        billingLoading: false,
        billingData: null,
        billingIsError: false,
        billingFilter: null
      };

    case actions.ADDING_BILLING_DATA_BY_MERCHANT_ID:
      return {
        ...state,
        billingIsError: false,
        billingLoading: true
      };

    case actions.ADD_BILLING_DATA_BY_MERCHANT_ID_SUCCESS:
      return {
        ...state,
        billingLoading: action.loading,
        errorMessage: action.message,
        billingIsError: false
      };

    case actions.ADD_BILLING_DATA_BY_MERCHANT_ID_FAILED:
      return {
        ...state,
        billingLoading: action.loading,
        errorMessage: action.message,
        billingIsError: true
      };

    case actions.FETCHING_BILLING_DETAILS:
      return {
        ...state,
        billingDetails: null,
        billingDetailsLoading: true
      };

    case actions.FETCH_BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        billingDetailsLoading: false,
        billingDetails: action.result,
        billingDetailsIsError: false,
        billingDataMerchantFee: action.merchant_fees
      };

    case actions.FETCH_BILLING_DETAILS_FAILED:
      return {
        ...state,
        billingDetailsLoading: false,
        billingDetails: action.result,
        billingDetailsIsError: true,
        billingDataMerchantFee: null
      };

    case actions.RESET_BILLING_DETAILS:
      return {
        ...state,
        billingDetailsLoading: false,
        billingDetails: null,
        billingDetailsIsError: false,
        billingDataMerchantFee: null
      };

    case actions.FETCHING_BILLER_DETAILS:
      return {
        ...state,
        billerDetails: null,
        billerDetailsLoading: true
      };

    case actions.FETCH_BILLER_DETAILS_SUCCESS:
      return {
        ...state,
        billerDetailsLoading: false,
        billerDetails: action.result,
        billerDetailsIsError: false
      };

    case actions.FETCH_BILLER_DETAILS_FAILED:
      return {
        ...state,
        billerDetailsLoading: false,
        billerDetails: action.result,
        billerDetailsIsError: true
      };

    case actions.RESET_BILLER_DETAILS:
      return {
        ...state,
        billerDetailsLoading: false,
        billerDetails: null,
        billerDetailsIsError: false
      };

    case actions.FETCHING_COLLATED_DATA_BY_PCHANNEL:
      return {
        ...state,
        collatedData: null,
        collatedDataLoading: true
      };

    case actions.FETCH_COLLATED_DATA_BY_PCHANNEL_SUCCESS:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedData: action.result,
        collatedDataIsError: false,
        collatedDataFilter: action.filter,
        collatedTotalCount: action.total
      };

    case actions.FETCH_COLLATED_DATA_BY_PCHANNEL_FAILED:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedData: action.result,
        collatedDataIsError: true,
        collatedDataFilter: action.filter
      };

    case actions.RESET_COLLATED_DATA_BY_PCHANNEL:
      return {
        ...state,
        collatedDataLoading: false,
        collatedData: null,
        collatedDataIsError: false,
        collatedDataFilter: null,
        collatedTotalCount: 0
      };

    case actions.ANALYZING_COLLATE_DATA_BY_PCHANNEL_DATA:
      return {
        ...state,
        collatedDataIsError: false,
        collatedDataLoading: true
      };

    case actions.ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA_SUCCESS:
      return {
        ...state,
        collatedDataLoading: action.loading,
        errorMessage: action.message,
        collatedDataIsError: false
      };

    case actions.ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA_FAILED:
      return {
        ...state,
        collatedDataLoading: action.loading,
        errorMessage: action.message,
        collatedDataIsError: true
      };
    case actions.ANALYZE_COLLATE_DATA_GENERATING_LOADING:
      return {
        ...state,
        analyzeMqttLoading: action.loading
      };
    case actions.PARSE_DATA_FILE_NOTIFIER:
      return {
        ...state,
        parseNotifierIsError: action.success,
        parseNotifierMessage: action.message
      };
    case actions.RESET_PARSE_DATA_FILE_NOTIFIER:
      return {
        ...state,
        parseNotifierIsError: false,
        parseNotifierMessage: null
      };

    case actions.PARSE_LEAD_DATA_FILE_NOTIFIER:
      return {
        ...state,
        parseLeadNotifierIsError: action.success,
        parseLeadNotifierMessage: action.message
      };
    case actions.RESET_PARSE_LEAD_DATA_FILE_NOTIFIER:
      return {
        ...state,
        parseLeadNotifierIsError: false,
        parseLeadNotifierMessage: null
      };

    case actions.GENERATING_REPORT_DATA:
      return {
        ...state,
        generateReportData: null,
        generateReportDataLoading: true
      };

    case actions.GENERATE_REPORT_DATA_SUCCESS:
      return {
        ...state,
        generateReportDataLoading: false,
        generateReportData: action.result,
        generateReportDataIsError: false,
        errorMessage: action.message
      };

    case actions.GENERATE_REPORT_DATA_FAILED:
      return {
        ...state,
        generateReportDataLoading: false,
        generateReportData: action.result,
        generateReportDataIsError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_SETTLEMENT_REPORT_DATA:
      return {
        ...state,
        downloadSettlementReportDataLoading: true
      };

    case actions.DOWNLOAD_SETTLEMENT_REPORT_DATA_SUCCESS:
      return {
        ...state,
        downloadSettlementReportDataLoading: false,
        downloadSettlementReportDataIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_SETTLEMENT_REPORT_DATA_FAILED:
      return {
        ...state,
        downloadSettlementReportDataLoading: false,
        downloadSettlementReportDataIsError: true,
        errorMessage: action.message
      };

    case actions.GENERATING_MONTH_REPORT_DATA:
      return {
        ...state,
        generateMonthReportData: null,
        generateMonthReportDataLoading: true
      };

    case actions.GENERATE_MONTH_REPORT_DATA_SUCCESS:
      return {
        ...state,
        generateMonthReportDataLoading: false,
        generateMonthReportData: action.result,
        generateMonthReportDataIsError: false,
        errorMessage: action.message
      };

    case actions.GENERATE_MONTH_REPORT_DATA_FAILED:
      return {
        ...state,
        generateMonthReportDataLoading: false,
        generateMonthReportData: action.result,
        generateMonthReportDataIsError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_MONTHLY_RECONCILED_REPORT:
      return {
        ...state,
        downloadMonthlyReconciledReportLoading: true
      };

    case actions.DOWNLOAD_MONTHLY_RECONCILED_REPORT_SUCCESS:
      return {
        ...state,
        downloadMonthlyReconciledReportLoading: false,
        downloadMonthlyReconciledReportIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_MONTHLY_RECONCILED_REPORT_FAILED:
      return {
        ...state,
        downloadMonthlyReconciledReportLoading: false,
        downloadMonthlyReconciledReportIsError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_CASE_DISCUSSION_ATTACHMENT:
      return {
        ...state,
        sendDiscussionLoading: true
      };

    case actions.DOWNLOAD_CASE_DISCUSSION_ATTACHMENT_SUCCESS:
      return {
        ...state,
        sendDiscussionLoading: false,
        sendDiscussionIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_CASE_DISCUSSION_ATTACHMENT_FAILED:
      return {
        ...state,
        sendDiscussionLoading: false,
        sendDiscussionIsError: true,
        errorMessage: action.message
      };

    case actions.CHECKING_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV:
      return {
        ...state,
        collatedDataLoading: true,
        collatedDataIsError: false
      };

    case actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV_SUCCESS:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedDataIsError: false,
        errorMessage: action.message
      };

    case actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV_FAILED:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedDataIsError: true,
        errorMessage: action.message
      };

    case actions.CHECKING_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE:
      return {
        ...state,
        collatedDataLoading: true,
        collatedDataIsError: false
      };

    case actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE_SUCCESS:
      return {
        ...state,
        collatedDataIsError: false,
        collatedDataLoading: action.loading,
        errorMessage: action.message
      };

    case actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE_FAILED:
      return {
        ...state,
        collatedDataIsError: true,
        collatedDataLoading: action.loading,
        errorMessage: action.message
      };
    case actions.FETCHING_SETTLEMENT_REPORT:
      return {
        ...state,
        // settlementReportData: null,
        settlementReportLoading: true
      };
    case actions.LOAD_MORE_SETTLEMENT_REPORT:
      return {
        ...state,
        settlementReportLoadMore: true
      };

    case actions.FETCH_SETTLEMENT_REPORT_SUCCESS:
      return {
        ...state,
        settlementReportLoading: action.loading,
        settlementReportData: action.result,
        settlementReportIsError: false,
        settlementReportPagination: action.pagination,
        settlementReportLoadMore: false,
        settlementReportFilter: action.filter
      };

    case actions.FETCH_SETTLEMENT_REPORT_FAILED:
      return {
        ...state,
        settlementReportLoading: action.loading,
        settlementReportData: action.result,
        settlementReportIsError: true,
        settlementReportLoadMore: false
      };
    case actions.RESET_SETTLEMENT_REPORT:
      return {
        ...state,
        settlementReportLoading: false,
        settlementReportData: null,
        settlementReportIsError: false,
        settlementReportPagination: null,
        settlementReportLoadMore: false,
        settlementReportFilter: null
      };

    case actions.FETCHING_MONTH_SETTLEMENT_REPORT:
      return {
        ...state,
        // settlementReportData: null,
        monthlySettlementReportLoading: true
      };
    case actions.LOAD_MORE_MONTH_SETTLEMENT_REPORT:
      return {
        ...state,
        monthlySettlementReportLoadMore: true
      };

    case actions.FETCH_MONTH_SETTLEMENT_REPORT_SUCCESS:
      return {
        ...state,
        monthlySettlementReportLoading: action.loading,
        monthlySettlementReportData: action.result,
        monthlySettlementReportIsError: false,
        monthlySettlementReportPagination: action.pagination,
        monthlySettlementReportLoadMore: false,
        monthlySettlementReportFilter: action.filter
      };

    case actions.FETCH_MONTH_SETTLEMENT_REPORT_FAILED:
      return {
        ...state,
        monthlySettlementReportLoading: action.loading,
        monthlySettlementReportData: action.result,
        monthlySettlementReportIsError: true,
        monthlySettlementReportLoadMore: false
      };
    case actions.RESET_MONTH_SETTLEMENT_REPORT:
      return {
        ...state,
        monthlySettlementReportLoading: false,
        monthlySettlementReportData: null,
        monthlySettlementReportIsError: false,
        monthlySettlementReportPagination: null,
        monthlySettlementReportLoadMore: false,
        monthlySettlementReportFilter: null
      };
    case actions.FETCHING_FINANCE_DASHBOARD_DATA:
      return {
        ...state,
        financeDashboardData: null,
        financeDashboardDataLoading: true
      };

    case actions.FETCH_FINANCE_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        financeDashboardDataLoading: action.loading,
        financeDashboardData: action.result,
        financeDashboardDataIsError: false,
        financeDashboardDataFilter: action.filter,
        financeDashboardDataPagination: action.pagination
      };

    case actions.FETCH_FINANCE_DASHBOARD_DATA_FAILED:
      return {
        ...state,
        financeDashboardDataLoading: action.loading,
        financeDashboardData: action.result,
        financeDashboardDataIsError: true
      };
    case actions.CHECKING_COLLATE_DATA:
      return {
        ...state,
        collatedDataLoading: true,
        collatedDataIsError: false
      };

    case actions.CHECK_COLLATE_DATA_SUCCESS:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedDataIsError: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.CHECK_COLLATE_DATA_FAILED:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedDataIsError: true,
        errorMessage: action.message,
        isError: true
      };

    case actions.CHECK_COLLATE_DATA_MQTT_LOADING:
      return {
        ...state,
        collatedMqttLoading: action.loading
      };
    case actions.FETCHING_ALL_RECONCILED_DATA:
      return {
        ...state,
        allReconciledData: null,
        allReconciledDataLoading: true
      };

    case actions.FETCH_ALL_RECONCILED_DATA_SUCCESS:
      return {
        ...state,
        allReconciledDataLoading: action.loading,
        allReconciledData: action.result,
        allReconciledDataIsError: false,
        allReconciledDataFilter: action.filter,
        allReconciledDataPagination: action.pagination
      };

    case actions.FETCH_ALL_RECONCILED_DATA_FAILED:
      return {
        ...state,
        allReconciledDataLoading: action.loading,
        allReconciledData: action.result,
        allReconciledDataIsError: true
      };
    case actions.GENERATING_UNRECONCILED_REPORT_DATA:
      return {
        ...state,
        unsettledTransactionLoading: true
      };

    case actions.GENERATE_UNRECONCILED_REPORT_DATA_SUCCESS:
      return {
        ...state,
        unsettledTransactionLoading: false,
        unsettledTransactionIsError: false,
        errorMessage: action.message
      };

    case actions.GENERATE_UNRECONCILED_REPORT_DATA_FAILED:
      return {
        ...state,
        unsettledTransactionLoading: false,
        unsettledTransactionIsError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_UNRECONCILED_REPORT_LIST:
      return {
        ...state,
        // settlementReportData: null,
        unreconciledReportLoading: true
      };
    case actions.LOAD_MORE_UNRECONCILED_REPORT_LIST:
      return {
        ...state,
        unreconciledReportLoadMore: true
      };

    case actions.FETCH_UNRECONCILED_REPORT_LIST_SUCCESS:
      return {
        ...state,
        unreconciledReportLoading: action.loading,
        unreconciledReportData: action.result,
        unreconciledReportIsError: false,
        unreconciledReportPagination: action.pagination,
        unreconciledReportLoadMore: false,
        unreconciledReportFilter: action.filter
      };

    case actions.FETCH_UNRECONCILED_REPORT_LIST_FAILED:
      return {
        ...state,
        unreconciledReportLoading: action.loading,
        unreconciledReportData: action.result,
        unreconciledReportIsError: true,
        unreconciledReportLoadMore: false
      };
    case actions.RESET_UNRECONCILED_REPORT_LIST_FAILED:
      return {
        ...state,
        unreconciledReportLoading: false,
        unreconciledReportData: null,
        unreconciledReportIsError: false,
        unreconciledReportPagination: null,
        unreconciledReportLoadMore: false,
        unreconciledReportFilter: null
      };

    case actions.DOWNLOADING_UNRECONCILED_REPORT_DATA:
      return {
        ...state,
        downloadUnreconciledLoading: true
      };

    case actions.DOWNLOAD_UNRECONCILED_REPORT_DATA_SUCCESS:
      return {
        ...state,
        downloadUnreconciledLoading: false,
        downloadUnreconciledIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_UNRECONCILED_REPORT_DATA_FAILED:
      return {
        ...state,
        downloadUnreconciledLoading: false,
        downloadUnreconciledIsError: true,
        errorMessage: action.message
      };
    case actions.STORE_PENDING_UNRECONCILED_REPORT_DATA:
      return {
        ...state,
        unreconciledReportData: action.payload
      };
    case actions.STORE_PENDING_RECONCILED_REPORT_DATA:
      return {
        ...state,
        settlementReportData: action.payload
      };
    case actions.STORE_PENDING_MONTH_REPORT_DATA:
      return {
        ...state,
        monthlySettlementReportData: action.payload
      };

    case actions.ESCALATING_TRANSACTION_DATA:
      return {
        ...state,
        escalateLoading: true
      };

    case actions.ESCALATE_TRANSACTION_DATA_SUCCESS:
      return {
        ...state,
        escalateLoading: false,
        collatedDataIsError: false,
        errorMessage: action.message
      };

    case actions.ESCALATE_TRANSACTION_DATA_FAILED:
      return {
        ...state,
        escalateLoading: false,
        collatedDataIsError: true,
        errorMessage: action.message
      };

    case actions.LIKING_TRANSACTION_DATA:
      return {
        ...state,
        likeLoading: true
      };

    case actions.LIKE_DISCUSSION_DATA_SUCCESS:
      return {
        ...state,
        likeLoading: false,
        likeIsError: false
        // errorMessage: action.message
      };

    case actions.LIKE_DISCUSSION_DATA_FAILED:
      return {
        ...state,
        likeLoading: false,
        likeIsError: true
        // errorMessage: action.message
      };

    case actions.FETCHING_CASE_DETAILS_DATA:
      return {
        ...state,
        caseDetails: null,
        caseDetailsLoading: true
      };

    case actions.FETCH_CASE_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        caseDetailsLoading: action.loading,
        caseDetail: action.result,
        caseDetailIsError: false
      };

    case actions.FETCH_CASE_DETAILS_DATA_FAILED:
      return {
        ...state,
        caseDetailsLoading: action.loading,
        caseDetail: action.result,
        caseDetailIsError: true
      };
    case actions.RESET_CASE_DETAILS:
      return {
        ...state,
        caseDetailsLoading: false,
        escalatedCaseData: action && action.payload ? action.payload : null,
        escalateLoading: false,
        caseDetail: null,
        caseDetailIsError: false
      };

    case actions.INVITING_CASE_MEMBER:
      return {
        ...state,
        inviteCaseMemberIsError: false,
        inviteCaseMemberLoading: true
      };

    case actions.INVITE_CASE_MEMBER_SUCCESS:
      return {
        ...state,
        inviteCaseMemberLoading: action.loading,
        errorMessage: action.message,
        inviteCaseMemberIsError: false
      };

    case actions.INVITE_CASE_MEMBER_FAILED:
      return {
        ...state,
        inviteCaseMemberLoading: action.loading,
        errorMessage: action.message,
        inviteCaseMemberIsError: true
      };
    case actions.FETCHING_CASE_TRANSACTION_DATA:
      return {
        ...state,
        escalatedCaseData: null,
        escalatedCaseDataLoading: true
      };
    case actions.LOAD_MORE_CASE_TRANSACTIONS:
      return {
        ...state,
        escalatedCaseDataLoadMore: true
      };

    case actions.FETCH_CASE_TRANSACTION_DATA_SUCCESS:
      return {
        ...state,
        escalatedCaseDataLoading: action.loading,
        escalatedCaseData: action.result,
        escalatedCaseDataIsError: false,
        escalatedCaseDataFilter: action.filter,
        escalatedCaseDataPagination: action.pagination,
        escalatedCaseDataLoadMore: false
      };
    case actions.SETUP_CASE_DETAIL:
      return {
        ...state,
        escalatedCaseData: action.result
      };

    case actions.FETCH_CASE_TRANSACTION_DATA_FAILED:
      return {
        ...state,
        escalatedCaseDataLoading: action.loading,
        escalatedCaseDataIsError: true,
        escalatedCaseDataLoadMore: false
      };

    case actions.FETCHING_CASE_DISCUSSIONS:
      return {
        ...state,
        caseDiscussionLoading: true
      };
    case actions.LOAD_MORE_CASE_DISCUSSIONS:
      return {
        ...state,
        caseDiscussionLoadMore: true
      };

    case actions.SET_DISCUSSION_VALUE:
      return {
        ...state,
        caseDiscussionData: action.payload
      };

    case actions.LIKE_CURRENT_ID:
      return {
        ...state,
        likedID: action.payload
      };

    case actions.FETCH_CASE_DISCUSSIONS_SUCCESS:
      return {
        ...state,
        caseDiscussionLoading: action.loading,
        caseDiscussionData: action.result,
        caseDiscussionIsError: false,
        caseDiscussionFilter: action.filter,
        caseDiscussionPagination: action.pagination,
        caseDiscussionLoadMore: false
      };

    case actions.FETCH_CASE_DISCUSSIONS_FAILED:
      return {
        ...state,
        caseDiscussionLoading: action.loading,
        caseDiscussionIsError: true,
        caseDiscussionLoadMore: false
      };
    case actions.UPDATING_CASE_DETAILS:
      return {
        ...state,
        caseDetailsLoading: true
      };

    case actions.UPDATE_CASE_DETAILS_SUCCESS:
      return {
        ...state,
        caseDetailsLoading: false,
        caseDetailIsError: false,
        errorMessage: action.message
      };

    case actions.UPDATE_CASE_DETAILS_FAILED:
      return {
        ...state,
        caseDetailsLoading: false,
        caseDetailIsError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_UPLOADED_BANK_FILES:
      return {
        ...state,
        uploadedBankFiles: null,
        pageLoading: action.loading,
        uploadedBankFilesLoading: action.loading
      };

    case actions.FETCH_UPLOADED_BANK_FILES_SUCCESS:
      return {
        ...state,
        uploadedBankFilesLoading: action.loading,
        pageLoading: action.loading,
        uploadedBankFiles: action.result,
        uploadedBankFilesIsError: false,
        uploadedBankFilesPagination: action.pagination,
        activeUploadedBank: action.activeBank
      };

    case actions.FETCH_UPLOADED_BANK_FILES_FAILED:
      return {
        ...state,
        uploadedBankFilesLoading: action.loading,
        pageLoading: action.loading,
        uploadedBankFiles: action.result,
        paynamicsBank: action.channel,
        uploadedBankFilesIsError: true,
        uploadedBankFilesPagination: action.pagination,
        activeUploadedBank: action.activeBank
      };

    case actions.FETCHING_UPLOADED_BANK_TRANSACTION:
      return {
        ...state,
        uploadedBankTransaction: null,
        pageLoading: action.loading,
        uploadedBankTransactionLoading: action.loading
        // bankTransactionFilter: action.bankTransactionFilter
      };

    case actions.FETCH_UPLOADED_BANK_TRANSACTION_SUCCESS:
      return {
        ...state,
        uploadedBankTransactionLoading: action.loading,
        pageLoading: action.loading,
        uploadedBankTransaction: action.result,
        uploadedBankTransactionIsError: false,
        uploadedBankTransactionPagination: action.pagination,
        bankTransactionFilter: action.bankTransactionFilter
      };

    case actions.FETCH_UPLOADED_BANK_TRANSACTION_FAILED:
      return {
        ...state,
        uploadedBankTransactionLoading: action.loading,
        pageLoading: action.loading,
        uploadedBankTransaction: action.result,
        paynamicsBank: action.channel,
        uploadedBankTransactionIsError: true
        // bankTransactionFilter: action.bankTransactionFilter
      };

    case actions.UPDATING_BANK_REMITTANCE:
      return {
        ...state,
        updateBankRemitIsLoading: true
      };

    case actions.UPDATE_BANK_REMITTANCE_SUCCESS:
      return {
        ...state,
        updateBankRemitIsLoading: false,
        uploadedBankTransactionIsError: false,
        errorMessage: action.message
      };

    case actions.UPDATE_BANK_REMITTANCE_FAILED:
      return {
        ...state,
        updateBankRemitIsLoading: false,
        uploadedBankTransactionIsError: true,
        errorMessage: action.message
      };

    case actions.UPDATING_BANK_TRANSACTION:
      return {
        ...state,
        updateBankTransactionIsLoading: true
      };

    case actions.UPDATE_BANK_TRANSACTION_SUCCESS:
      return {
        ...state,
        updateBankTransactionIsLoading: false,
        updateBankTransactionIsError: false,
        errorMessage: action.message
      };

    case actions.UPDATE_BANK_TRANSACTION_FAILED:
      return {
        ...state,
        updateBankTransactionIsLoading: false,
        updateBankTransactionIsError: true,
        errorMessage: action.message
      };
    case actions.UPDATING_BANK_FILE:
      return {
        ...state,
        updateBankFileIsLoading: true
      };

    case actions.UPDATE_BANK_FILE_SUCCESS:
      return {
        ...state,
        updateBankFileIsLoading: false,
        uploadedBankFilesLoading: false,
        updateBankFileIsError: false,
        errorMessage: action.message
      };

    case actions.UPDATE_BANK_FILE_FAILED:
      return {
        ...state,
        updateBankFileIsLoading: false,
        uploadedBankFilesLoading: true,
        updateBankFileIsError: true,
        errorMessage: action.message
      };

    case actions.GENERATING_BANK_TRANSACTION_STATISTICS:
      return {
        ...state,
        bankTransactionStatistics: null,
        pageLoading: action.loading,
        bankTransactionFilter: action.bankTransactionFilter
      };

    case actions.GENERATE_BANK_TRANSACTION_STATISTICS_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        bankTransactionStatistics: action.result,
        bankTransactionStatisticsIsError: false,
        bankTransactionFilter: action.bankTransactionFilter
      };

    case actions.GENERATE_BANK_TRANSACTION_STATISTICS_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        bankTransactionStatistics: action.result,
        bankTransactionStatisticsIsError: true,
        bankTransactionFilter: action.bankTransactionFilter
      };

    case actions.FETCHING_ALL_REMITTING_CHANNEL_SCHEDULE:
      return {
        ...state,
        remittingChannelScheduleLoading: action.loading
      };

    case actions.FETCH_ALL_REMITTING_CHANNEL_SCHEDULE_SUCCESS:
      return {
        ...state,
        remittingChannelSchedule: action.result,
        remittingChannelScheduleLoading: action.loading,
        remittingChannelScheduleIsError: false
      };

    case actions.FETCH_ALL_REMITTING_CHANNEL_SCHEDULE_FAILED:
      return {
        ...state,
        remittingChannelScheduleLoading: action.loading,
        remittingChannelScheduleIsError: true
      };

    case actions.ADDING_REMITTING_CHANNEL_SCHEDULE:
      return {
        ...state,
        remittingChannelScheduleLoading: action.loading,
        remittingChannelScheduleIsError: false
      };

    case actions.ADD_REMITTING_CHANNEL_SCHEDULE_SUCCESS:
      return {
        ...state,
        remittingChannelScheduleLoading: action.loading,
        remittingChannelScheduleIsError: false,
        errorMessage: action.message
      };

    case actions.ADD_REMITTING_CHANNEL_SCHEDULE_FAILED:
      return {
        ...state,
        remittingChannelScheduleLoading: action.loading,
        remittingChannelScheduleIsError: true,
        errorMessage: action.message
      };

    case actions.EDITING_REMITTING_CHANNEL_SCHEDULE:
      return {
        ...state,
        remittingChannelScheduleLoading: action.loading,
        remittingChannelScheduleIsError: false
      };

    case actions.EDIT_REMITTING_CHANNEL_SCHEDULE_SUCCESS:
      return {
        ...state,
        remittingChannelScheduleLoading: action.loading,
        remittingChannelScheduleIsError: false,
        errorMessage: action.message
      };

    case actions.EDIT_REMITTING_CHANNEL_SCHEDULE_FAILED:
      return {
        ...state,
        remittingChannelScheduleLoading: action.loading,
        remittingChannelScheduleIsError: true,
        errorMessage: action.message
      };

    case actions.DELETING_UPLOADED_BANK_FILE_AND_TRANSACTIONS:
      return {
        ...state,
        deleteBankFileAndTransactionsIsLoading: action.loading
      };

    case actions.DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        deleteBankFileAndTransactionsIsLoading: action.loading,
        deleteBankFileAndTransactionsIsError: false,
        errorMessage: action.message
      };

    case actions.DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS_FAILED:
      return {
        ...state,
        deleteBankFileAndTransactionsIsLoading: action.loading,
        deleteBankFileAndTransactionsIsError: true,
        errorMessage: action.message
      };

    case actions.SET_ACTIVE_CHANNEL_SCHEDULE:
      return {
        ...state,
        activeRemittingChannelSchedule: action.payload
      };

    case actions.SET_PNX_BANK_COLUMN:
      return {
        ...state,
        pnxBankColumn: action.payload
      };

    case actions.FETCHING_TRANSACTION_LIST:
      return {
        ...state,
        fetchingTrxList: true
      };
    case actions.FETCH_TRANSACTION_LIST_RESET:
      return {
        ...state,
        transactionList: null,
        transactionListCount: 0,
        transactionListCollection: null,
        transactionListPage: 1,
        isFiltered: false
      };
    case actions.FETCHED_TRANSACTION_LIST_FINAL:
      return {
        ...state,
        transactionList: action.payload,
        transactionListCount: action.count,
        transactionListCollection: action.collection,
        transactionListTemp: null,
        transactionListPage: action.page,
        fetchingTrxList: false,
        fetchingMoreTrx: false
      };
    case actions.FETCHED_TRANSACTION_LIST:
      return {
        ...state,
        transactionListCollection: action.collection
        // transactionListTemp: action.payload,
      };
    case actions.FETCHING_MORE_TRANSACTION_LIST:
      return {
        ...state,
        fetchingMoreTrx: true
      };
    case actions.FETCH_TRANSACTION_LIST_FAILED:
      return {
        ...state,
        fetchingTrxList: false,
        transactionList: [],
        errorMessage: action.message
      };
    case actions.RESET_TRANSACTION_LIST:
      return {
        ...state,
        transactionList: null
      };

    case actions.SET_IS_FILTERED:
      return {
        ...state,
        isFiltered: true
      };

    case actions.FETCHING_TRANSACTION_DETAILS:
      return {
        ...state,
        fetchingTrxDetails: true
      };
    case actions.FETCHED_TRANSACTION_DETAILS:
      return {
        ...state,
        trxDetails: action.payload,
        fetchingTrxDetails: false
      };
    case actions.FETCH_TRANSACTION_DETAILS_FAILED:
      return {
        ...state,
        fetchingTrxDetails: false,
        errorMessage: action.error
      };

    case actions.RESET_TRANSACTION_DETAILS:
      return {
        ...state,
        trxDetails: null
      };

    case actions.FETCHING_OTC_TRANSACTIONS:
      return {
        ...state,
        otcTransactionsData: null,
        otcTransactionsLoading: true
      };

    case actions.FETCH_OTC_TRANSACTIONS_SUCCESS:
      return {
        ...state,

        otcTransactionsData: action.result,
        otcTransactionsLoading: action.loading,
        otcTransactionsIsError: false,
        otcTransactionsFilter: action.filter
      };

    case actions.FETCH_OTC_TRANSACTIONS_FAILED:
      return {
        ...state,
        otcTransactionsData: action.result,
        otcTransactionsLoading: action.loading,
        otcTransactionsIsError: true,
        errorMessage: action.message
      };

    case actions.UPDATING_OTC_TRANSACTIONS:
      return {
        ...state,
        otcTransactionsLoading: true
      };

    case actions.UPDATE_OTC_TRANSACTIONS_SUCCESS:
      return {
        ...state,

        otcTransactionsLoading: action.loading,
        otcTransactionsIsError: false,
        errorMessage: action.message
      };

    case actions.UPDATE_OTC_TRANSACTIONS_FAILED:
      return {
        ...state,
        otcTransactionsLoading: action.loading,
        otcTransactionsIsError: true,
        errorMessage: action.message
      };
    case actions.DOWNLOADED_CSV:
      return {
        ...state,
        csvDownloadFile: action.payload,
        isDownloadCsv: false
      };
    case actions.DOWNLOADING_CSV:
      return {
        ...state,
        isDownloadCsv: true
      };
    case actions.CLEAR_DOWNLOAD_CSV:
      return {
        ...state,
        csvDownloadFile: null,
        isDownloadCsv: false
      };
    case actions.DOWNLOD_FAILED_CSV:
      return {
        ...state,
        csvDownloadFile: null,
        isDownloadCsv: false,
      };

    case actions.FETCHING_EXCEL_DOWNLOAD_LIST:
      return {
        ...state,
        fetchingExcelDownloadList: true
      };
    case actions.FETCHED_EXCEL_DOWNLOAD_LIST:
      return {
        ...state,
        excelDownloadList: action.payload,
        fetchingExcelDownloadList: false
      };
    case actions.DOWNLOAD_STATUS:
      return {
        ...state,
        downloadStatus: action.payload
      };
    case actions.FETCH_EXCEL_DOWNLOAD_LIST_FAILED:
      return {
        ...state,
        fetchingExcelDownloadList: false,
        excelDownloadList: []
      };

    case actions.FETCHING_PREVIOUS_DOWNLOADS:
      return {
        ...state,
        fetchingPrevDownloads: true
      };
    case actions.FETCHED_PREVIOUS_DOWNLOADS:
      return {
        ...state,
        previousDownloads: action.payload,
        fetchingPrevDownloads: false
      };
    case actions.FETCH_PREVIOUS_DOWNLOADS_FAILED:
      return {
        ...state,
        fetchingPrevDownloads: false,
        previousDownloads: []
      };

    case actions.FETCHING_MERCHANTS:
      return {
        ...state,
        fetchingMerchants: true
      };
    case actions.FETCHED_MERCHANTS:
      return {
        ...state,
        merchants: action.payload,
        fetchingMerchants: false
      };
    case actions.FETCH_MERCHANTS_FAILED:
      return {
        ...state,
        fetchingMerchants: false,
        merchants: []
      };
      case actions.FETCHING_CUSTOM_MERCHANT_PARAMS:
      return {
        ...state,
        fetchingMerchantParams: true,
        fetchedMerchantParams: null,        
      };
    case actions.FETCHED_CUSTOM_MERCHANT_PARAMS:
      return {
        ...state,
        fetchingMerchantParams: false,
        fetchedMerchantParams: action.payload
      };
    case actions.FETCH_CUSTOM_MERCHANT_PARAMS_FAILED:
      return {
        ...state,
        fetchingMerchantParams: false,
        fetchedMerchantParams: null
      };
    case actions.FETCH_CUSTOM_MERCHANT_PARAMS_RESET:
      return {
        ...state,
        fetchedMerchantParams: null,
      };
    case actions.FETCHING_DOWNLOAD_REPORT:
      return {
        ...state,
        fetchingDownloadReport: true
      };
    case actions.FETCHED_DOWNLOAD_REPORT:
      return {
        ...state,
        fetchingDownloadReport: false,
        fetchedDownloadReport: action.message
      };
    case actions.FETCH_DOWNLOAD_REPORT_FAILED:
      return {
        ...state,
        fetchingDownloadReport: false,
        fetchedDownloadReport: action.message
      };
    case actions.FETCH_DOWNLOAD_REPORT_RESET:
      return {
        ...state,
        fetchingDownloadReport: false,
        fetchedDownloadReport: null
      };

    case actions.FETCHING_ALL_FINANCE_OPERATIONS:
      return {
        ...state,
        financeOperations: null,
        financeOperationsLoading: true
      };

    case actions.LOADING_MORE_FINANCE_OPERATIONS:
      return {
        ...state,
        financeOperationsLoadMore: true
      };

    case actions.FETCH_ALL_FINANCE_OPERATIONS_SUCCESS:
      return {
        ...state,
        financeOperationsLoading: action.loading,
        financeOperations: action.result,
        financeOperationsIsError: false,
        financeOperationsFilter: action.filter,
        financeOperationsPagination: action.pagination,
        financeOperationsLoadMore: false,
        activeFinanceOperations: null
      };

    case actions.FETCH_ALL_FINANCE_OPERATIONS_FAILED:
      return {
        ...state,
        financeOperationsLoading: action.loading,
        financeOperationsIsError: true,
        financeOperationsLoadMore: false
      };

    case actions.FETCHING_FINANCE_OPERATIONS_BY_ID:
      return {
        ...state,
        activeFinanceOperations: null,
        pageLoading: action.loading,
        activeFinanceOperationsLoading: action.loading,
        financeOperationsLogsData: null,
        financeOperationsLogsLoading: true
      };

    case actions.FETCH_FINANCE_OPERATIONS_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeFinanceOperations: action.result,
        isError: false,
        activeFinanceOperationsLoading: action.loading
      };

    case actions.FETCH_FINANCE_OPERATIONS_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeFinanceOperations: null,
        isError: true,
        activeFinanceOperationsLoading: action.loading
      };

    case actions.FETCHING_FINANCE_OPERATIONS_LOGS:
      return {
        ...state,
        financeOperationsLogsLoading: action.loading,
        financeOperationsLogsData: null
      };

    case actions.FETCH_FINANCE_OPERATIONS_LOGS_SUCCESS:
      return {
        ...state,
        financeOperationsLogsLoading: action.loading,
        financeOperationsLogsData: action.result,
        financeOperationsLogsIsError: false,
        financeOperationsLogsPagination: action.pagination,
        financeOperationsLogsLoadMore: false
      };

    case actions.LOADING_MORE_FINANCE_OPERATIONS_LOGS:
      return {
        ...state,
        financeOperationsLogsLoadMore: true
      };

    case actions.FETCH_FINANCE_OPERATIONS_LOGS_FAILED:
      return {
        ...state,
        financeOperationsLogsLoading: action.loading,
        financeOperationsLogsData: action.result,
        financeOperationsLogsIsError: true,
        financeOperationsLogsPagination: action.pagination,
        financeOperationsLogsLoadMore: false
      };
    case actions.RESET_FINANCE_OPERATIONS_LOGS:
      return {
        ...state,
        financeOperationsLogsLoading: false,
        financeOperationsLogsData: null,
        financeOperationsLogsIsError: false,
        financeOperationsLogsPagination: null,
        financeOperationsLogsLoadMore: false
      };

    case actions.DOWNLOADING_VAT_EXEMPTION_FILE_FINANCE:
      return {
        ...state,
        downloadVatExemptionLoading: true,
        pageLoading: true
      };

    case actions.DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE_SUCCESS:
      return {
        ...state,
        downloadVatExemptionLoading: false,
        pageLoading: false,
        downloadVatExemptionIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE_FAILED:
      return {
        ...state,
        downloadVatExemptionLoading: false,
        pageLoading: false,
        downloadVatExemptionIsError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_PAYMENT_PROOF_FILE_FINANCE:
      return {
        ...state,
        downloadPaymentProofLoading: true,
        pageLoading: true,
        isError: false
      };

    case actions.DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE_SUCCESS:
      return {
        ...state,
        downloadPaymentProofLoading: false,
        pageLoading: false,
        downloadPaymentProofIsError: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE_FAILED:
      return {
        ...state,
        downloadPaymentProofLoading: false,
        pageLoading: false,
        downloadPaymentProofIsError: true,
        errorMessage: action.message,
        isError: true
      };

    case actions.APPROVING_VAT_EXEMPTION_FILE:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true
      };

    case actions.APPROVE_VAT_EXEMPTION_FILE_SUCCESS:
      return {
        ...state,
        activeFinanceOperationsLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.APPROVE_VAT_EXEMPTION_FILE_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.REJECTING_VAT_EXEMPTION_FILE:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true
      };

    case actions.REJECT_VAT_EXEMPTION_FILE_SUCCESS:
      return {
        ...state,
        activeFinanceOperationsLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.REJECT_VAT_EXEMPTION_FILE_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.CONFIRMING_PAYMENT_PROOF_FILE:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true,
        financeOperationsLoading: true
      };

    case actions.CONFIRM_PAYMENT_PROOF_FILE_SUCCESS:
      return {
        ...state,
        // activeFinanceOperationsLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        financeOperationsLoading: false
      };

    case actions.CONFIRM_PAYMENT_PROOF_FILE_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false,
        financeOperationsLoading: false
      };

    case actions.RESET_FINANCE_OPERATIONS:
      return {
        ...state,
        financeOperationsLoading: false,
        financeOperations: null,
        financeOperationsIsError: false,
        financeOperationsFilter: null,
        financeOperationsPagination: null,
        financeOperationsLoadMore: false,
        activeFinanceOperations: null,
        activeFinanceOperationsLoading: null,

        financeOperationsLogsLoading: false,
        financeOperationsLogsData: null,
        financeOperationsLogsIsError: false,
        financeOperationsLogsPagination: null,
        financeOperationsLogsLoadMore: false,

        downloadVatExemptionLoading: false,
        downloadVatExemptionIsError: false
      };

    case actions.VIEWING_CONFIDENTIAL_BANK_DETAILS:
      return {
        ...state,
        decryptedAccountNumberLoading: action.loading,
        decryptedAccountNumber: null
      };

    case actions.VIEW_CONFIDENTIAL_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        decryptedAccountNumberLoading: action.loading,
        decryptedAccountNumber: action.result,
        decryptedAccountNumberIsError: false,
        errorMessage: action.message
      };

    case actions.VIEW_CONFIDENTIAL_BANK_DETAILS_FAILED:
      return {
        ...state,
        decryptedAccountNumberLoading: action.loading,
        decryptedAccountNumber: action.result,
        decryptedAccountNumberIsError: true,
        errorMessage: action.message
      };

    case actions.EDITING_INVOICE:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true
      };

    case actions.EDIT_INVOICE_SUCCESS:
      return {
        ...state,
        activeFinanceOperationsLoading: true,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.EDIT_INVOICE_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.VIEWING_INVOICE_PDF:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        invoicePDFUrlLoading: true,
        invoicePDFUrl: null
      };

    case actions.VIEW_INVOICE_PDF_SUCCESS:
      return {
        ...state,
        invoicePDFUrlLoading: action.loading,
        invoicePDFUrl: action.url,
        pageLoading: false,
        isError: false
      };

    case actions.VIEW_INVOICE_PDF_FAILED:
      return {
        ...state,
        invoicePDFUrlLoading: action.loading,
        invoicePDFUrl: action.url,
        isError: true,
        pageLoading: false
      };

    case actions.VIEWING_VAT_REVERSAL_ATTACHMENT:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        vatReversalAttachmentUrlLoading: true,
        vatReversalAttachmentUrl: null
      };

    case actions.VIEW_VAT_REVERSAL_ATTACHMENT_SUCCESS:
      return {
        ...state,
        vatReversalAttachmentUrlLoading: action.loading,
        vatReversalAttachmentUrl: action.url,
        pageLoading: false,
        isError: false
      };

    case actions.VIEW_VAT_REVERSAL_ATTACHMENT_FAILED:
      return {
        ...state,
        vatReversalAttachmentUrlLoading: action.loading,
        vatReversalAttachmentUrl: action.url,
        isError: true,
        pageLoading: false
      };

    case actions.VIEWING_PAYMENT_PROOF_PDF:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        paymentProofPDFUrlLoading: true,
        paymentProofPDFUrl: null
      };

    case actions.VIEW_PAYMENT_PROOF_PDF_SUCCESS:
      return {
        ...state,
        paymentProofPDFUrlLoading: action.loading,
        paymentProofPDFUrl: action.url,
        pageLoading: false,
        isError: false
      };

    case actions.VIEW_PAYMENT_PROOF_PDF_FAILED:
      return {
        ...state,
        paymentProofPDFUrlLoading: action.loading,
        paymentProofPDFUrl: action.url,
        isError: true,
        pageLoading: false
      };

    case actions.REQUESTING_VAT_EXEMPT_REVERSAL:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true
      };

    case actions.REQUEST_VAT_EXEMPT_REVERSAL_SUCCESS:
      return {
        ...state,
        activeFinanceOperationsLoading: true,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
      };

    case actions.REQUEST_VAT_EXEMPT_REVERSAL_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false,
      };

    case actions.FETCHING_REVERSAL_REQUEST_BY_ID:
      return {
        ...state,
        isError: false,
        fetchingReversalRequest: true
      };

     case actions.FETCH_REVERSAL_REQUEST_BY_ID_SUCCESS:
      return {
        ...state,
        fetchingReversalRequest: false,
        //errorMessage: action.message,
        fetchedReversalRequest: action.result,
        pageLoading: false,
        isError: false,
      };

    case actions.FETCH_REVERSAL_REQUEST_BY_ID_FAILED:
      return {
        ...state,
        //errorMessage: action.message,
        fetchingReversalRequest: action.loading,
        fetchedReversalRequest: null,
        isError: true,
        pageLoading: false,
      };

      case actions.APPROVING_VAT_EXEMPT_REVERSAL:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true
      };

    case actions.APPROVE_VAT_EXEMPT_REVERSAL_SUCCESS:
      return {
        ...state,
        activeFinanceOperationsLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.APPROVE_VAT_EXEMPT_REVERSAL_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false
      };


    case actions.REQUESTING_INVOICE_APPROVAL:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true
      };

    case actions.REQUEST_INVOICE_APPROVAL_SUCCESS:
      return {
        ...state,
        activeFinanceOperationsLoading: true,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        presignedUrlEsignature: null
      };

    case actions.REQUEST_INVOICE_APPROVAL_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false,
        presignedUrlEsignature: null
      };

    case actions.FETCHING_ALL_FINANCE_USERS:
      return {
        ...state,
        financeUsers: null,
        financeUsersLoading: true
      };

    case actions.FETCH_ALL_FINANCE_USERS_SUCCESS:
      return {
        ...state,
        financeUsers: action.result,
        financeUsersLoading: action.loading,
        financeUsersIsError: false
      };

    case actions.FETCH_ALL_FINANCE_USERS_FAILED:
      return {
        ...state,
        financeUsersLoading: action.loading,
        financeUsersIsError: true
      };

    case actions.STORING_ESIGNATURE:
      return {
        ...state,
        presignedUrlEsignatureLoading: action.loading
      };

    case actions.STORE_ESIGNATURE_SUCCESS:
      return {
        ...state,
        presignedUrlEsignatureLoading: action.loading,
        presignedUrlEsignature: action.result,
        presignedUrlEsignatureIsError: false
      };

    case actions.STORE_ESIGNATURE_FAILED:
      return {
        ...state,
        presignedUrlEsignatureLoading: action.loading,
        presignedUrlEsignature: action.result,
        presignedUrlEsignatureIsError: true
      };

    case actions.REJECTING_INVOICE:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true
      };

    case actions.REJECT_INVOICE_SUCCESS:
      return {
        ...state,
        activeFinanceOperationsLoading: true,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.REJECT_INVOICE_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.APPROVING_INVOICE:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true
      };

    case actions.APPROVE_INVOICE_SUCCESS:
      return {
        ...state,
        activeFinanceOperationsLoading: true,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        presignedUrlEsignature: null
      };

    case actions.APPROVE_INVOICE_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false,
        presignedUrlEsignature: null
      };

     case actions.STORING_VAT_REVERSAL_ATTACHMENT:
      return {
        ...state,
        presignedUrlsReversalAttachmentLoading: action.loading
      };

    case actions.STORE_VAT_REVERSAL_ATTACHMENT_SUCCESS:
      return {
        ...state,
        presignedUrlsReversalAttachmentLoading: action.loading,
        presignedUrlsReversalAttachment: action.result,
       presignedUrlsReversalAttachmentIsError: false
      };

    case actions.STORE_VAT_REVERSAL_ATTACHMENT_FAILED:
      return {
        ...state,
        presignedUrlsReversalAttachmentLoading: action.loading,
        presignedUrlsReversalAttachment: action.result,
        presignedUrlsReversalAttachmentIsError: true
      };

    case actions.STORING_PAYMENT_PROOF_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsPaymentProofLoading: action.loading
      };

    case actions.STORE_PAYMENT_PROOF_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsPaymentProofLoading: action.loading,
        presignedUrlsPaymentProof: action.result,
        presignedUrlsPaymentProofIsError: false
      };

    case actions.STORE_PAYMENT_PROOF_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsPaymentProofLoading: action.loading,
        presignedUrlsPaymentProof: action.result,
        presignedUrlsPaymentProofIsError: true
      };

    case actions.MANAGING_PAYMENT_PROOF_FILES:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true,
        financeOperationsLoading: true
      };

    case actions.MANAGE_PAYMENT_PROOF_FILES_SUCCESS:
      return {
        ...state,
        // activeFinanceOperationsLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        presignedUrlsPaymentProof: null,
        financeOperationsLoading: false
      };

    case actions.MANAGE_PAYMENT_PROOF_FILES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        // activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false,
        presignedUrlsPaymentProof: null,
        financeOperationsLoading: false
      };

    case actions.SENDING_MERCHANT_INVOICE:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true
      };

    case actions.SEND_MERCHANT_INVOICE_SUCCESS:
      return {
        ...state,
        activeFinanceOperationsLoading: true,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.SEND_MERCHANT_INVOICE_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_ALL_SETTLEMENT_CYCLE:
      return {
        ...state,
        settlementCycleData: null,
        settlementCycleDataLoading: true
      };

    case actions.LOADING_MORE_SETTLEMENT_CYCLE:
      return {
        ...state,
        settlementCycleDataLoadMore: true
      };

    case actions.FETCH_ALL_SETTLEMENT_CYCLE_SUCCESS:
      return {
        ...state,
        settlementCycleDataLoading: action.loading,
        settlementCycleData: action.result,
        settlementCycleDataIsError: false,
        settlementCycleDataFilter: action.filter,
        settlementCycleDataPagination: action.pagination,
        settlementCycleDataLoadMore: false,
        activeSettlementCycle: null
      };

    case actions.FETCH_ALL_SETTLEMENT_CYCLE_FAILED:
      return {
        ...state,
        settlementCycleDataLoading: action.loading,
        settlementCycleDataIsError: true,
        settlementCycleDataLoadMore: false
      };

    case actions.FETCHING_SETTLEMENT_CYCLE_BY_ID:
      return {
        ...state,
        activeSettlementCycle: null,
        pageLoading: action.loading,
        activeSettlementCycleLoading: action.loading
      };

    case actions.FETCH_SETTLEMENT_CYCLE_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeSettlementCycle: action.result,
        isError: false,
        activeSettlementCycleLoading: action.loading
      };

    case actions.FETCH_SETTLEMENT_CYCLE_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeSettlementCycle: null,
        isError: true,
        activeSettlementCycleLoading: action.loading
      };

    case actions.FETCHING_SETTLEMENT_RATE_BY_ID:
      return {
        ...state,
        activeSettlementRate: null,
        pageLoading: action.loading,
        activeSettlementRateLoading: action.loading
      };

    case actions.FETCH_SETTLEMENT_RATE_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeSettlementRate: action.result,
        isError: false,
        activeSettlementRateLoading: action.loading
      };

    case actions.FETCH_SETTLEMENT_RATE_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeSettlementRate: null,
        isError: true,
        activeSettlementRateLoading: action.loading
      };

    case actions.ADDING_SETTLEMENT_CYCLE:
      return {
        ...state,
        settlementCycleDataIsError: false,
        settlementCycleDataLoading: true
      };

    case actions.ADD_SETTLEMENT_CYCLE_SUCCESS:
      return {
        ...state,
        settlementCycleDataLoading: action.loading,
        errorMessage: action.message,
        settlementCycleDataIsError: false
      };

    case actions.ADD_SETTLEMENT_CYCLE_FAILED:
      return {
        ...state,
        settlementCycleDataLoading: action.loading,
        errorMessage: action.message,
        settlementCycleDataIsError: true
      };

    case actions.EDITING_SETTLEMENT_CYCLE:
      return {
        ...state,
        settlementCycleDataIsError: false,
        settlementCycleDataLoading: true
      };

    case actions.EDIT_SETTLEMENT_CYCLE_SUCCESS: {
      const settlementCycleData = state.settlementCycleData ?? [];

      return {
        ...state,
        settlementCycleDataLoading: action.loading,
        errorMessage: action.message,
        settlementCycleDataIsError: false,
        settlementCycleData: settlementCycleData.map(item =>
          item?.id === action?.id ? { ...item, ...(action?.data ?? {}) } : item
        )
      };
    }

    case actions.EDIT_SETTLEMENT_CYCLE_FAILED:
      return {
        ...state,
        settlementCycleDataLoading: action.loading,
        errorMessage: action.message,
        settlementCycleDataIsError: true
      };

    case actions.CREATING_BILLING_ADDITIONAL_FEE:
      return {
        ...state,
        billingAdditionalFeeDataIsError: false,
        billingAdditionalFeeDataLoading: true
      };

    case actions.CREATE_BILLING_ADDITIONAL_FEE_SUCCESS:
      return {
        ...state,
        billingAdditionalFeeDataLoading: action.loading,
        errorMessage: action.message,
        billingAdditionalFeeDataIsError: false
      };

    case actions.CREATE_BILLING_ADDITIONAL_FEE_FAILED:
      return {
        ...state,
        billingAdditionalFeeDataLoading: action.loading,
        errorMessage: action.message,
        billingAdditionalFeeDataIsError: true
      };

    case actions.FETCHING_ALL_BILLING_ADDITIONAL_FEE:
      return {
        ...state,
        billingAdditionalFeeData: null,
        billingAdditionalFeeDataLoading: true
      };

    case actions.LOADING_MORE_BILLING_ADDITIONAL_FEE:
      return {
        ...state,
        billingAdditionalFeeDataLoadMore: true
      };

    case actions.FETCH_ALL_BILLING_ADDITIONAL_FEE_SUCCESS:
      return {
        ...state,
        billingAdditionalFeeDataLoading: action.loading,
        billingAdditionalFeeData: action.result,
        billingAdditionalFeeDataIsError: false,
        billingAdditionalFeeDataFilter: action.filter,
        billingAdditionalFeeDataPagination: action.pagination,
        billingAdditionalFeeDataLoadMore: false,
        activebillingAdditionalFee: null
      };

    case actions.FETCH_ALL_BILLING_ADDITIONAL_FEE_FAILED:
      return {
        ...state,
        billingAdditionalFeeDataLoading: action.loading,
        billingAdditionalFeeDataIsError: true,
        billingAdditionalFeeDataLoadMore: false
      };

    case actions.FETCHING_BILLING_ADDITIONAL_FEE_BY_ID:
      return {
        ...state,
        activeBillingAdditionalFee: null,
        pageLoading: action.loading,
        activeBillingAdditionalFeeLoading: action.loading
      };

    case actions.FETCH_BILLING_ADDITIONAL_FEE_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeBillingAdditionalFee: action.result,
        isError: false,
        activeBillingAdditionalFeeLoading: action.loading
      };

    case actions.FETCH_BILLING_ADDITIONAL_FEE_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeBillingAdditionalFee: null,
        isError: true,
        activeBillingAdditionalFeeLoading: action.loading
      };

    case actions.UPDATING_BILLING_ADDITIONAL_FEE:
      return {
        ...state,
        activeBillingAdditionalFeeIsError: false,
        pageLoading: true
      };

    case actions.UPDATE_BILLING_ADDITIONAL_FEE_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeBillingAdditionalFeeErrorMessage: action.message,
        activeBillingAdditionalFeeIsError: false
      };

    case actions.UPDATE_BILLING_ADDITIONAL_FEE_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeBillingAdditionalFeeErrorMessage: action.message,
        activeBillingAdditionalFeeIsError: true
      };

    case actions.FETCHING_BILLING_CONFIGURATION_LOGS:
      return {
        ...state,
        billingConfigurationLogsLoading: action.loading,
        billingConfigurationLogsData: null
      };

    case actions.FETCH_BILLING_CONFIGURATION_LOGS_SUCCESS:
      return {
        ...state,
        billingConfigurationLogsLoading: action.loading,
        billingConfigurationLogsData: action.result,
        billingConfigurationLogsIsError: false,
        billingConfigurationLogsPagination: action.pagination,
        billingConfigurationLogsLoadMore: false
      };

    case actions.LOADING_MORE_BILLING_CONFIGURATION_LOGS:
      return {
        ...state,
        billingConfigurationLogsLoadMore: true
      };

    case actions.FETCH_BILLING_CONFIGURATION_LOGS_FAILED:
      return {
        ...state,
        billingConfigurationLogsLoading: action.loading,
        billingConfigurationLogsData: action.result,
        billingConfigurationLogsIsError: true,
        billingConfigurationLogsPagination: action.pagination,
        billingConfigurationLogsLoadMore: false
      };
    case actions.RESET_BILLING_CONFIGURATION_LOGS:
      return {
        ...state,
        billingConfigurationLogsLoading: false,
        billingConfigurationLogsData: null,
        billingConfigurationLogsIsError: false,
        billingConfigurationLogsPagination: null,
        billingConfigurationLogsLoadMore: false
      };

    case actions.GENERATING_SUMMARY_BREAKDOWN_REPORT:
      return {
        ...state,
        summaryBreakdownReportLoading: true,
        summaryBreakdownReportIsError: false,
        pageLoading: true
      };

    case actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_SUCCESS:
      return {
        ...state,
        // summaryBreakdownReportLoading: action.loading,
        summaryBreakdownReportIsError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_FAILED:
      return {
        ...state,
        summaryBreakdownReportLoading: action.loading,
        summaryBreakdownReportIsError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATING_SUMMARY_BREAKDOWN_REPORT_V2:
      return {
        ...state,
        summaryBreakdownReportLoading: true,
        summaryBreakdownReportIsError: false,
        pageLoading: true
      };

    case actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_V2_SUCCESS:
      return {
        ...state,
        // summaryBreakdownReportLoading: action.loading,
        summaryBreakdownReportIsError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_V2_FAILED:
      return {
        ...state,
        summaryBreakdownReportLoading: action.loading,
        summaryBreakdownReportIsError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.EDITING_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT:
      return {
        ...state,
        pageLoading: true,
        // merchantFromOnboardingLoading: true,
        isError: false
      };

    case actions.EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT_SUCCESS:
      return {
        ...state,
        // merchantFromOnboardingLoading: action.loading,
        isError: false,
        errorMessage: action.message,
        pageLoading: false
        // activeMerchantFromOnboarding: null
      };

    case actions.EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT_FAILED:
      return {
        ...state,
        // merchantFromOnboardingLoading: action.loading,
        pageLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.CREATING_CHANGE_REQUEST_RATES:
      return {
        ...state,
        pageLoading: true,
        // merchantFromOnboardingLoading: true,
        isError: false
      };

    case actions.CREATE_CHANGE_REQUEST_RATES_SUCCESS:
      return {
        ...state,
        // merchantFromOnboardingLoading: action.loading,
        isError: false,
        errorMessage: action.message,
        pageLoading: false,
        presignedUrlsAddendum: null

        // activeMerchantFromOnboarding: null
      };

    case actions.CREATE_CHANGE_REQUEST_RATES_FAILED:
      return {
        ...state,
        // merchantFromOnboardingLoading: action.loading,
        pageLoading: false,
        isError: true,
        errorMessage: action.message,

        presignedUrlsAddendum: null
      };

    case actions.REJECTING_CHANGE_REQUEST_RATES:
    case actions.APPROVING_CHANGE_REQUEST_RATES_BY_SALES:
    case actions.APPROVING_CHANGE_REQUEST_RATES_BY_FINANCE:
      return {
        ...state,
        pageLoading: true,
        isError: false
      };

    case actions.REJECT_CHANGE_REQUEST_RATES_SUCCESS:
    case actions.APPROVE_CHANGE_REQUEST_RATES_BY_SALES_SUCCESS:
    case actions.APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_SUCCESS:
      return {
        ...state,
        isError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.REJECT_CHANGE_REQUEST_RATES_FAILED:
    case actions.APPROVE_CHANGE_REQUEST_RATES_BY_SALES_FAILED:
    case actions.APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_FAILED:
      return {
        ...state,
        pageLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_ADDENDUM_DOCUMENT:
      return {
        ...state,
        downloadAddendumDocumentLoading: true
      };

    case actions.DOWNLOAD_ADDENDUM_DOCUMENT_SUCCESS:
      return {
        ...state,
        downloadAddendumDocumentLoading: false,
        downloadAddendumDocumentIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_ADDENDUM_DOCUMENT_FAILED:
      return {
        ...state,
        downloadAddendumDocumentLoading: false,
        downloadAddendumDocumentIsError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_FEE_HISTORY:
      return {
        ...state,
        feeHistoryLoading: action.loading
      };

    case actions.FETCH_FEE_HISTORY_SUCCESS:
      return {
        ...state,
        feeHistoryLoading: action.loading,
        feeHistoryData: action.result,
        feeHistoryIsError: false,
        feeHistoryPagination: action.pagination,
        feeHistoryLoadMore: false
      };

    case actions.LOADING_MORE_FEE_HISTORY:
      return {
        ...state,
        feeHistoryLoadMore: true
      };

    case actions.FETCHING_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA:
      return {
        ...state,
        allGeneratedSettlementSummaryReportFileData: null,
        allGeneratedSettlementSummaryReportDataLoading: action.loading
      };

    case actions.FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA_SUCCESS:
      return {
        ...state,
        allGeneratedSettlementSummaryReportDataLoading: action.loading,
        allGeneratedSettlementSummaryReportFileData: action.result,
        allGeneratedSettlementSummaryReportFileDataIsError: false,
        allGeneratedSettlementSummaryReportFileDataPagination: action.pagination
      };

    case actions.FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA_FAILED:
      return {
        ...state,
        allGeneratedSettlementSummaryReportDataLoading: action.loading,
        allGeneratedSettlementSummaryReportFileData: action.result,
        allGeneratedSettlementSummaryReportFileDataIsError: true,
        allGeneratedSettlementSummaryReportFileDataPagination: action.pagination
      };

    case actions.DOWNLOADING_SETTLEMENT_SUMMARY_REPORT:
      return {
        ...state,
        isDownloadingSettlementSummaryReportFile: true
      };

    case actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        isDownloadingSettlementSummaryReportFile: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED:
      return {
        ...state,
        isDownloadingSettlementSummaryReportFile: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.STORING_ADDENDUM_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsAddendumLoading: action.loading
      };

    case actions.STORE_ADDENDUM_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsAddendumLoading: action.loading,
        presignedUrlsAddendum: action.result,
        presignedUrlsAddendumIsError: false
      };

    case actions.STORE_ADDENDUM_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsAddendumLoading: action.loading,
        presignedUrlsAddendum: action.result,
        presignedUrlsAddendumIsError: true
      };

    case actions.SET_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER:
      return {
        ...state,
        summaryBreakdownReportPchannelFilter: action.payload
      };

    case actions.RESET_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER:
      return {
        ...state,
        summaryBreakdownReportPchannelFilter: []
      };

    case actions.RESET_GENERATED_MONTHLY_RECONCILED_FILTER:
      return {
        ...state,
        generatedMonthlyReconciledFilter: []
      };

    case actions.SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER:
      return {
        ...state,
        isError: null,
        errorMessage: null
      };

    case actions.SAVING_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER:
      return {
        ...state,
        isSavingSummaryBreakdownReportPchannelFilter: true
      };

    case actions.SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_SUCCESS:
      return {
        ...state,
        isError: action.isError,
        errorMessage: action.message,
        isSavingSummaryBreakdownReportPchannelFilter: false
      };

    case actions.SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_FAILED:
      return {
        ...state,
        isError: action.isError,
        errorMessage: action.message,
        isSavingSummaryBreakdownReportPchannelFilter: false
      };

    case actions.FETCH_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER:
      return {
        ...state
      };

    case actions.FETCH_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_FAILED:
      return {
        ...state,
        isError: action.isError,
        errorMessage: action.message
      };

    case actions.RESET_ADDENDUM_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsAddendum: null
      };

    case actions.CLEAR_PRESIGNED_ESIGNATURE:
      return {
        ...state,
        presignedUrlEsignature: null
      };

    case actions.TAGGING_AS_FLOATING:
      return {
        ...state,
        collatedDataLoading: true,
        collatedDataIsError: false
      };

    case actions.TAG_AS_FLOATING_SUCCESS:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedDataIsError: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.TAG_AS_FLOATING_FAILED:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedDataIsError: true,
        errorMessage: action.message,
        isError: true
      };

    case actions.FINDING_SINGLE_TRANSACTION_LOOSELY:
      return {
        ...state,
        collatedDataLoading: true,
        collatedMqttLoading: true,
        collatedDataIsError: false
      };

    case actions.FIND_SINGLE_TRANSACTION_LOOSELY_SUCCESS:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedMqttLoading: action.loading,
        collatedDataIsError: false,
        errorMessage: null,
        isError: false,
        foundSnowflakeTransactionData: action.data,
        selectedUploadedData: action.payload
      };

    case actions.FIND_SINGLE_TRANSACTION_LOOSELY_FAILED:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedMqttLoading: action.loading,
        collatedDataIsError: true,
        errorMessage: action.message,
        isError: true,
        foundSnowflakeTransactionData: null,
        selectedUploadedData: null
      };

    case actions.STORING_RECON_PROOF_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsForReconProofLoading: action.loading
      };

    case actions.STORE_RECON_PROOF_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsForReconProofLoading: action.loading,
        presignedUrlsForReconProofData: action.result,
        presignedUrlsForReconProofIsError: false
      };

    case actions.STORE_RECON_PROOF_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsForReconProofLoading: action.loading,
        presignedUrlsForReconProofData: action.result,
        presignedUrlsForReconProofIsError: true
      };

    case actions.CONFIRMING_MANUAL_RECON:
      return {
        ...state,
        collatedDataLoading: true,
        collatedMqttLoading: true,
        reconciliationLoading: true,
        collatedDataIsError: false
      };

    case actions.CONFIRM_MANUAL_RECON_SUCCESS:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedMqttLoading: action.loading,
        collatedDataIsError: false,
        errorMessage: action.message,
        isError: false,
        selectedUploadedData: null,
        foundSnowflakeTransactionData: null
      };

    case actions.CONFIRM_MANUAL_RECON_FAILED:
      return {
        ...state,
        collatedDataLoading: action.loading,
        collatedMqttLoading: action.loading,
        collatedDataIsError: true,
        errorMessage: action.message,
        isError: true,
        selectedUploadedData: null,
        foundSnowflakeTransactionData: null
      };

    case actions.DOWNLOADING_MANUAL_RECON_PROOF:
      return {
        ...state,
        downloadManualReconProofLoading: true
      };

    case actions.DOWNLOAD_MANUAL_RECON_PROOF_SUCCESS:
      return {
        ...state,
        downloadManualReconProofLoading: false,
        downloadManualReconProofIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_MANUAL_RECON_PROOF_FAILED:
      return {
        ...state,
        downloadManualReconProofLoading: false,
        downloadManualReconProofIsError: true,
        errorMessage: action.message
      };

    case actions.EDITING_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS:
      return {
        ...state,
        pageLoading: true,
        isError: false
      };

    case actions.EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_SUCCESS:
      return {
        ...state,
        isError: false,
        errorMessage: action.message,
        pageLoading: false,
        presignedUrlsAddendum: null
      };

    case actions.EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_FAILED:
      return {
        ...state,
        pageLoading: false,
        isError: true,
        errorMessage: action.message,
        presignedUrlsAddendum: null
      };

    case actions.CREATING_TRANSACTION_DELETION_REQUEST:
      return {
        ...state,
        transactionRequestManagementLoading: true,
        transactionRequestManagementIsError: false,
        isError: false,
        collatedDataIsError: false,
        errorMessage: null
      };

    case actions.CREATE_TRANSACTION_DELETION_REQUEST_SUCCESS:
      return {
        ...state,
        transactionRequestManagementLoading: false,
        transactionRequestManagementIsError: false,
        isError: false,
        collatedDataIsError: false,
        errorMessage: action.message
      };

    case actions.CREATE_TRANSACTION_DELETION_REQUEST_FAILED:
      return {
        ...state,
        transactionRequestManagementLoading: false,
        transactionRequestManagementIsError: true,
        isError: true,
        collatedDataIsError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_TRANSACTION_REQUESTS:
      return {
        ...state,
        transactionRequests: null,
        transactionRequestsLoading: true
      };

    case actions.FETCH_TRANSACTION_REQUESTS_SUCCESS:
      return {
        ...state,
        transactionRequestsLoading: action.loading,
        transactionRequests: action.result,
        transactionRequestsIsError: false,
        transactionRequestsFilter: action.filter,
        transactionRequestsPagination: action.pagination
      };

    case actions.FETCH_TRANSACTION_REQUESTS_FAILED:
      return {
        ...state,
        transactionRequestsLoading: action.loading,
        transactionRequests: action.result,
        transactionRequestsIsError: true
      };

    case actions.UPDATING_TRANSACTION_REQUEST_STATUS:
      return {
        ...state,
        transactionRequestsLoading: action.loading,
        isError: false,
        collatedDataIsError: false
      };

    case actions.UPDATE_TRANSACTION_REQUEST_STATUS_SUCCESS:
      const requestId = action?.result?.id;

      return {
        ...state,
        transactionRequestsLoading: action.loading,
        transactionRequests: state.transactionRequests.map(tx =>
          tx.id === requestId ? { ...action?.result } : tx
        ),
        transactionRequestsIsError: false,
        isError: false,
        collatedDataIsError: false,
        errorMessage: action.message
      };

    case actions.UPDATE_TRANSACTION_REQUEST_STATUS_FAILED:
      return {
        ...state,
        transactionRequestsLoading: action.loading,
        transactionRequestsIsError: true,
        isError: true,
        errorMessage: action.message,
        collatedDataIsError: true
      };

    case actions.CREATING_CATEGORIZE_FLOATING_TRANSACTION_REQUEST:
      return {
        ...state,
        transactionRequestManagementLoading: true,
        transactionRequestManagementIsError: false,
        isError: false,
        collatedDataIsError: false,
        errorMessage: null
      };

    case actions.CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST_SUCCESS:
      return {
        ...state,
        transactionRequestManagementLoading: false,
        transactionRequestManagementIsError: false,
        isError: false,
        collatedDataIsError: false,
        errorMessage: action.message
      };

    case actions.CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST_FAILED:
      return {
        ...state,
        transactionRequestManagementLoading: false,
        transactionRequestManagementIsError: true,
        isError: true,
        collatedDataIsError: true,
        errorMessage: action.message
      };

    case actions.CREATING_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST:
      return {
        ...state,
        transactionRequestManagementLoading: true,
        transactionRequestManagementIsError: false,
        isError: false,
        collatedDataIsError: false,
        errorMessage: null
      };

    case actions.CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST_SUCCESS:
      return {
        ...state,
        transactionRequestManagementLoading: false,
        transactionRequestManagementIsError: false,
        isError: false,
        collatedDataIsError: false,
        errorMessage: action.message
      };

    case actions.CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST_FAILED:
      return {
        ...state,
        transactionRequestManagementLoading: false,
        transactionRequestManagementIsError: true,
        isError: true,
        collatedDataIsError: true,
        errorMessage: action.message
      };

    case actions.TAGGING_RECONCILED_TRANSACTION:
      return {
        ...state,
        allReconciledDataLoading: true,
        allReconciledDataIsError: false,
        isError: false,
        collatedDataIsError: false,
        errorMessage: null
      };

    case actions.TAG_RECONCILED_TRANSACTION_SUCCESS:
      const updatedIds = action.result;

      return {
        ...state,
        allReconciledDataLoading: false,
        allReconciledDataIsError: false,
        allReconciledData: state.allReconciledData.map(data => {
          const updateId = updatedIds.find(update => update.id === data.id);
          return updateId ? { ...data, ...updateId } : data;
        }),
        isError: false,
        collatedDataIsError: false,
        errorMessage: action.message
      };

    case actions.TAG_RECONCILED_TRANSACTION_FAILED:
      return {
        ...state,
        allReconciledDataLoading: false,
        allReconciledDataIsError: true,
        isError: true,
        collatedDataIsError: true,
        errorMessage: action.message
      };

    case actions.TAGGING_UNMATCHED_AS_ENDORSED:
      return {
        ...state,
        collatedDataLoading: true,
        isError: false,
        collatedDataIsError: false,
        errorMessage: null
      };

    case actions.TAG_UNMATCHED_AS_ENDORSED_SUCCESS:
      const updatedTrxs = action.result;

      return {
        ...state,
        collatedDataLoading: false,
        collatedData: state.collatedData.map(data => {
          const updatedTrx = updatedTrxs.find(
            update =>
              update.request_id === data.request_id && update.record_type === data.record_type
          );
          return updatedTrx ? { ...data, ...updatedTrx } : data;
        }),
        isError: false,
        collatedDataIsError: false,
        errorMessage: action.message
      };

    case actions.TAG_UNMATCHED_AS_ENDORSED_FAILED:
      return {
        ...state,
        collatedDataLoading: false,
        isError: true,
        collatedDataIsError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_ALL_APPROVED_FILTERED_DATE:
      return {
        ...state,
        approvedListFilteredDate: null,
        approvedListFilteredDateIsError: true,
        approvedListFilteredDateLoading: true
      };

    case actions.FETCH_ALL_APPROVED_FILTERED_DATE_SUCCESS:
      return {
        ...state,
        approvedListFilteredDateLoading: false,
        approvedListFilteredDate: action.result,
        approvedListFilteredDateIsError: false
      };

    case actions.FETCH_ALL_APPROVED_FILTERED_DATE_FAILED:
      return {
        ...state,
        approvedListFilteredDateLoading: false,
        approvedListFilteredDate: null,
        approvedListFilteredDateIsError: true
      };

    case actions.NOTIFYING_UNRECONCILED_TRANSACTIONS:
      return {
        ...state,
        collatedDataLoading: true,
        allReconciledDataLoading: true,
        isError: false,
        errorMessage: null
      };
    case actions.NOTIFY_UNRECONCILED_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        collatedDataLoading: false,
        allReconciledDataLoading: false,
        isError: false,
        errorMessage: action.message
      };
    case actions.NOTIFY_UNRECONCILED_TRANSACTIONS_FAILED:
      return {
        ...state,
        collatedDataLoading: false,
        allReconciledDataLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_APPROVED_FILTERED_DATE_DETAILS:
      return {
        ...state,
        approvedPaymentChannelData: null,
        approvedPaymentChannelDataLoading: true,
        approvedPaymentChannelDataIsError: false
      };

    case actions.FETCH_APPROVED_FILTERED_DATE_DETAILS_SUCCESS:
      return {
        ...state,
        approvedPaymentChannelDataLoading: false,
        approvedPaymentChannelDataIsError: false,
        approvedPaymentChannelData: action.result,
        isError: false
        // errorMessage: action.message
      };

    case actions.FETCH_APPROVED_FILTERED_DATE_DETAILS_FAILED:
      return {
        ...state,
        approvedPaymentChannelDataLoading: false,
        approvedPaymentChannelDataIsError: false,
        isError: true
        // errorMessage: action.message
      };

    case actions.FETCHING_UNRECONCILED_PTI_GROUP_MERCHANT:
      return {
        ...state,
        unreconciledPTIGroupMerchantData: null,
        unreconciledPTIGroupMerchantDataLoading: true,
        unreconciledPTIGroupMerchantDataIsError: false
      };

    case actions.FETCH_UNRECONCILED_PTI_GROUP_MERCHANT_SUCCESS:
      return {
        ...state,
        unreconciledPTIGroupMerchantData: action.result,
        unreconciledPTIGroupMerchantDataLoading: false,
        unreconciledPTIGroupMerchantDataIsError: false
      };

    case actions.FETCH_UNRECONCILED_PTI_GROUP_MERCHANT_FAILED:
      return {
        ...state,
        unreconciledPTIGroupMerchantDataLoading: false,
        unreconciledPTIGroupMerchantDataIsError: true
      };

    case actions.GENERATING_SUMMARY_RECONCILIATION_REPORT:
      return {
        ...state,
        generateSummaryReconciliationReportLoading: action.loading,
        generateSummaryReconciliationReportIsError: false,
        isError: false,
        errorMessage: null
      };

    case actions.GENERATE_SUMMARY_RECONCILIATION_REPORT_SUCCESS:
      return {
        ...state,
        generateSummaryReconciliationReportLoading: action.loading,
        generateSummaryReconciliationReportIsError: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.GENERATE_SUMMARY_RECONCILIATION_REPORT_FAILED:
      return {
        ...state,
        generateSummaryReconciliationReportLoading: action.loading,
        generateSummaryReconciliationReportIsError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_GENERATED_SUMMARY_RECONCILIATION_REPORT:
      return {
        ...state,
        isDownloadingGeneratedSummaryReconciliationReport: true,
        isError: false,
        errorMessage: null
      };

    case actions.DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT_SUCCESS:
      return {
        ...state,
        isDownloadingGeneratedSummaryReconciliationReport: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT_FAILED:
      return {
        ...state,
        isDownloadingGeneratedSummaryReconciliationReport: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES:
      return {
        ...state,
        generatedSummaryReconciliationReportDataLoading: action.loading,
        generatedSummaryReconciliationReportDataIsError: false
      };

    case actions.FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES_SUCCESS:
      return {
        ...state,
        generatedSummaryReconciliationReportDataLoading: action.loading,
        generatedSummaryReconciliationReportDataIsError: false,
        generatedSummaryReconciliationReportData: action.result,
        generatedSummaryReconciliationReportDataPagination: action.pagination
      };

    case actions.FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES_FAILED:
      return {
        ...state,
        generatedSummaryReconciliationReportDataLoading: action.loading,
        generatedSummaryReconciliationReportDataIsError: true,
        generatedSummaryReconciliationReportData: action.result,
        generatedSummaryReconciliationReportDataPagination: action.pagination
      };

    case actions.DOWNLOADING_UPLOADED_BANK_FILE:
      return {
        ...state,
        downloadUploadedBankFileIsError: action.loading
      };

    case actions.DOWNLOAD_UPLOADED_BANK_FILE_SUCCESS:
      return {
        ...state,
        downloadUploadedBankFileLoading: action.loading,
        downloadUploadedBankFileIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_UPLOADED_BANK_FILE_FAILED:
      return {
        ...state,
        downloadUploadedBankFileLoading: action.loading,
        downloadUploadedBankFileIsError: true,
        errorMessage: action.message
      };

    case authActions.LOGOUT:
      // reset all redux param values
      return initState;
    default:
      return state;
  }
};
